import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import { socials } from "../data/socialItems";
import heroImg from "../assets/heroImg.jpg";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <section
      name="home"
      id="home"
      className="w-full py-20 md:h-screen bg-[#0a192f]"
    >
      {/* Container */}
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col-reverse md:flex-row items-center justify-center h-full">
        <div className="md:ml-8 mobile-only:flex flex-col items-center justify-center mt-4">
          <p className="text-primary-color text-2xl">Hi🙋, my name is</p>
          <h1 className="text-4xl sm:text-6xl font-bold text-[#ccd6f6]">
            Ayush Agrawal
          </h1>
          <h2 className="text-2xl sm:text-4xl font-semibold mt-2 text-[#8892b0]">
            I'm a Full Stack Developer.
          </h2>
          <p className="text-[#8892b0] py-4 max-w-[700px] text-justify">
            “As a Software Engineer with over 3+ years of industry experience,
            I specialize in crafting highly scalable, robust and performant web
            applications. My go-to tech stacks include React, Angular, JS for 
            frontend development and Java Spring Boot, Nodejs, Express for 
            backend services.🚀”
          </p>
          <div className="lg:hidden flex gap-4 my-4 justify-center items-center">
            {socials?.map(({ id, icon, href }) => (
              <span
                key={id}
                className="bg-gray-400 rounded-full p-2 hover:bg-primary-color duration-200 hover:scale-110"
              >
                <ion-icon name="social">
                  <a href={href} target="_blank" rel="noreferrer">
                    {icon}
                  </a>
                </ion-icon>
              </span>
            ))}
          </div>
          <div className="">
            <Link to={"work"} smooth={true} duration={500}>
              <button className="text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-primary-color hover:border-primary-color">
                View Work
                <span className="group-hover:rotate-90 duration-300">
                  <HiArrowNarrowRight className="ml-3 " />
                </span>
              </button>
            </Link>
          </div>
        </div>
        <div>
          <img
            src={heroImg}
            alt="profile"
            className="rounded-full mx-auto w-1/2 md:w-3/5"
          />
        </div>
      </div>
    </section>
  );
};

export default Home;

/*
a cutom hook can be written to check the device type which will use window.mediaQuery
*/
